import smoothscroll from 'smoothscroll-polyfill';

import initializeApp, { Params } from 'Jsx/Shared/LayoutV2/initializeApp';

import thirdPartyLoader from 'Utils/thirdPartyLoader/thirdPartyLoader';
import gtagProvider from 'Utils/thirdPartyLoader/gtagProvider';
import gtmProvider from 'Utils/thirdPartyLoader/gtmProvider';
import facebookPixelProvider from 'Utils/thirdPartyLoader/facebookPixelProvider';

import App from './App';

import localeEs from './i18n/localeEs';
import localePt from './i18n/localePt';

import getInitialState from './getInitialState';

import { initialStatePageKey, MEMBERSHIP_PAGE_KEY } from './constants';

smoothscroll.polyfill();
window.__forceSmoothScrollPolyfill__ = true;

function loadThirdParty() {
  thirdPartyLoader({
    providers: [gtagProvider(), gtmProvider(), facebookPixelProvider()],
  });
}

const appConfig: Params = {
  App,
  getInitialState,
  initialStatePageKey,
  i18nConfig: {
    pageKey: MEMBERSHIP_PAGE_KEY,
    defaults: {
      ...localeEs,
      ...localePt,
    },
  },
  layoutProps: {
    userActivityPageView: {
      type: 'membership',
    },
  },
  extraState: {},
  onReactDOMRender: () => {
    loadThirdParty();
  },
};

initializeApp(appConfig);
